import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Navbar from '../layout/Navbar';
import Preloader from '../layout/preloader';
import ExameTopo from '../section-pages/exame-topo';
import ExameTexto from '../section-pages/exame-texto';
import Footer from '../section-pages/footer';
import ScrollToTopBtn from '../layout/ScrollToTop';
import ApiExame from '../services/exameService';
import ExamesInscricao from '../section-pages/exames-inscricao';

export default function Exame() {
  const { slug } = useParams();

  const [exame, setExame] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  // 🔹 Buscar exame
  const fetchExame = useCallback(async () => {
    try {
      setIsLoading(true);
      const response = await ApiExame.obterPorUrl(slug);
      const exameData = response?.data?.exame?.[0] || null;
      setExame(exameData);
    } catch (error) {
      console.error('Erro ao buscar exame:', error);
      setExame(null);
    } finally {
      setIsLoading(false);
    }
  }, [slug]);

  useEffect(() => {
    if (slug) {
      fetchExame();
    }
  }, [slug, fetchExame]);

  // 🔹 Remover preloader
  useEffect(() => {
    const loader = document.getElementById('mainpreloader');
    if (loader) {
      setTimeout(() => {
        loader.classList.add('fadeOut');
        loader.style.display = 'none';
      }, 600);
    }
  }, []);

  // 🔹 Verificar se inscrição está aberta
  const inscricaoAberta = useMemo(() => {
    if (!exame?.dataInicio || !exame?.dataFim) return false;

    const hoje = new Date();
    hoje.setHours(0, 0, 0, 0);

    const [anoInicio, mesInicio, diaInicio] = exame.dataInicio.split("-");
    const [anoFim, mesFim, diaFim] = exame.dataFim.split("-");

    const inicio = new Date(anoInicio, mesInicio - 1, diaInicio);
    inicio.setHours(0, 0, 0, 0);

    const fim = new Date(anoFim, mesFim - 1, diaFim);
    fim.setHours(23, 59, 59, 999);

    return hoje >= inicio && hoje <= fim;
  }, [exame]);

  return (
    <>
      {/* HEAD */}
      <Helmet>
        <link rel="icon" href="./img/icon.png" />
        <title>Fetron - Federação de Taekwondô de Rondônia</title>
      </Helmet>

      {/* LOADER */}
      <div id="mainpreloader">
        <Preloader />
      </div>

      <div className="home dark-scheme">
        <header id="header-wrap">
          <Navbar />
        </header>

        <section>
          {isLoading ? (
            <p>Carregando exame...</p>
          ) : exame ? (
            <ExameTopo
              foto={exame.foto}
              titulo={exame.nome}
              dataExame={exame.data}
              inscricaoAberta={inscricaoAberta}
            />
          ) : (
            <p>Exame não encontrado.</p>
          )}
        </section>

        <section className="noticia-section">
          {exame && <ExameTexto exame={exame} />}
        </section>

        <section className="noticia-section">
          { inscricaoAberta && (
            <ExamesInscricao exame={exame} />
          )}
        </section>

        <Footer />
      </div>

      <ScrollToTopBtn />
    </>
  );
}
